import {Table, Tag, Image} from "antd";
import * as API_TREES from "../../../../../shared/http/trees";
import {CreateTree} from "../../../../modalwindows/admin/CreateTree";
import {useEffect, useState} from "react";
import {GEButton} from "../../../../../common/buttons";
import Constants from "../../../../../const/Constants";


const statusMap = {
    WATERED: {text: "Полито", color: "green"},
    NEED_WATER: {text: "Нуждается в поливе", color: "orange"},
    DEAD: {text: "Засохло", color: "red"},
    JUST_PLANTED: {text: "Только посажено", color: "purple"},
    none: {text: "-", color: "red"}
};

// @ts-ignore
const StatusTag = ({status}) => {
    // @ts-ignore
    const s = statusMap[status];
    return <Tag color={s.color}>{s.text}</Tag>;
};

export const AdminTrees = () => {

    const [showCreateModel, setShowCreateModal] = useState<boolean>(false)
    const [trees, setTrees] = useState<any>()


    useEffect(() => {
        API_TREES.getAll().then(resp => {
            console.log(resp)
            if (resp && resp.length > 0) {

                const result = resp.map((r: any) => {
                    const children = [];
                    children.push({
                        key: r.id + "1",
                        name: r.name,
                        status: 'WATERED',
                        image: `${Constants.queryConst}/v1/trees/image/${r.id}/WATERED`
                    })

                    children.push({
                        key: r.id + "2",
                        name: r.name,
                        status: 'NEED_WATER',
                        image: `${Constants.queryConst}/v1/trees/image/${r.id}/NEED_WATER`
                    })

                    children.push({
                        key: r.id + "3",
                        name: r.name,
                        status: 'DEAD',
                        image: `${Constants.queryConst}/v1/trees/image/${r.id}/DEAD`
                    })

                    children.push({
                        key: r.id + "4",
                        name: r.name,
                        status: 'JUST_PLANTED',
                        image: `${Constants.queryConst}/v1/trees/image/${r.id}/JUST_PLANTED`
                    })

                    const mainTree = {
                        key: r.id,
                        name: r.name,
                        status: "none",
                        children: children
                    }
                    return mainTree;
                });

                setTrees(result)
            }

        })
    }, []);


    const columns = [
        {
            title: "Дерево",
            dataIndex: "name",
            key: "name",
        },
        {
            title: "Состояние",
            dataIndex: "status",
            key: "status",
            // @ts-ignore
            render: (status) => <StatusTag status={status}/>,
        },
        {
            title: "Изображение",
            dataIndex: "image",
            key: "image",
            // @ts-ignore
            render: (src) => (
                <Image
                    src={src}
                    width={60}
                    height={60}
                    style={{objectFit: "cover", borderRadius: 8}}
                />
            ),
        },
    ];


    return (
        <div id='admin-trees'>
            {trees && <Table
                columns={columns}
                dataSource={trees}
                pagination={false}
                expandable={{defaultExpandAllRows: true}}
            />}
            <CreateTree close={() => {
                setShowCreateModal(false)
            }} isOpen={showCreateModel}/>
            <GEButton onClick={() => setShowCreateModal(true)}>Создать дерево</GEButton>
        </div>
    )
}
